/**
 *  Vuex Rest API
 *
 *  @model Device
 */
import Vapi from 'vuex-rest-api'
import apiConfig from '@/config/api'
import { getPaginated } from '@/helpers/general'
import { axiosInstance } from '../../plugins/axios'


// TODO: also exists in tags
const setMessage = (type, message, error) => {
  const errorOrEmpty = error ? `: ${error}` : ''
  return { show: true, type, message: `${message}`, errorOrEmpty }
}

/**
 *  Devices on REST API
 */
const api = new Vapi({
  axios: axiosInstance,
  baseURL: apiConfig.url,
  state: {
    device: {},
    devices: [],
    deviceUpdate: {},
    deviceUpdates: [],
    entity: {},
    entities: []
  }
}).get({
  action: 'getUnit',
  property: 'device',
  path: ({ id }) => `/devices/${id}`
}).get({
  action: 'getDeviceUpdate',
  property: 'deviceUpdate',
  path: ({ id }) => `/device-updates/${id}`
}).post({
  action: 'createDeviceUpdate',
  property: 'deviceUpdate',
  path: () => '/device-updates'
}).get({
  action: 'getDeviceUpdates',
  property: 'deviceUpdates',
  path: () => '/device-updates'
}).get({
  action: 'getTripsByDeviceId',
  property: 'device',
  path: ({ device_id, range }) => `/trips?search=${device_id}&searchFields=device_id`
}).get({
  action: 'getUnits',
  property: 'devices',
  path: (params) => getPaginated(params, 'devices')
}).get({
  action: 'getDevices',
  property: 'devices',
  path: (params) => getPaginated(params, 'search/devices')
}).get({
  action: 'getEntity',
  property: 'entity',
  path: ({ id }) => `/entities/${id}`
}).get({
  action: 'getEntities',
  property: 'entities',
  path: (params) => getPaginated(params, 'entities')
}).get({
  action: 'getMissingEntities',
  property: 'missing',
  path: '/entities/missing'
}).post({
  action: 'reportMissingEntity',
  property: 'missing',
  path: ({ id }) => `/entities/${id}/missing`,
  onError: (state, error) => {
    state.error = setMessage('error', `${error.response.data.message}`)
  }
}).put({
  action: 'updateUnit',
  property: 'device',
  path: ({ id }) => `/devices/${id}`
}).put({
  action: 'updateDevice',
  property: 'device',
  path: ({ id }) => `/devices/${id}`
}).post({
  action: 'installDevice',
  property: 'entity',
  path: 'entities/install-device'
}).post({
  action: 'replaceEntity',
  property: 'entity',
  path: ({ id }) => `/entities/${id}/replace`
}).post({
  action: 'createEntity',
  property: 'entity',
  path: '/entities'
}).post({
  action: 'createUnit',
  property: 'device',
  path: '/devices'
}).post({
  action: 'createDevice',
  property: 'device',
  path: '/devices'
}).post({
  action: 'linkDevices',
  property: 'device',
  path: 'sub-vendors/link'
}).post({
  action: 'attachDevicesToEnterprise',
  property: 'device',
  path: '/devices/link-to-enterprise'
}).post({
  action: 'attachEntitiesToVendor',
  property: 'entities',
  path: '/entities/attach-to-vendor'
}).put({
  action: 'updateEntity',
  property: 'entity',
  path: ({ id }) => `/entities/${id}`
}).delete({
  action: 'deleteUnit',
  property: 'device',
  path: ({ id }) => `/devices/${id}`
}).delete({
  action: 'deleteEntity',
  property: 'entity',
  path: ({ id }) => `/entities/${id}`
}).delete({
  action: 'deleteDeviceUpdate',
  property: 'deviceUpdate',
  path: ({ id }) => `/device-updates/${id}`
}).delete({
  action: 'deleteUnits',
  property: 'device',
  path: ({ device_ids }) => '/devices'
})
// TODO: Factor up so tags and entities can use it.
  .post({
    action: 'attachTags',
    property: 'tags',
    path: () => '/tags/attach'
  })

const Entities = api.getStore({
  namespaced: true,
  createStateFn: true
})

Entities.mutations = {
  ...Entities.mutations
}

export default Entities
